// Use secure backend API instead of direct CouchDB access
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
};

// Direct CouchDB access configuration using environment variables
export const COUCHDB_CONFIG = {
  url: (process.env.REACT_APP_API_URL || 'http://localhost:5000') + '/api',
  database: process.env.REACT_APP_COUCHDB_DATABASE || 'client_db'
};